import axios from '../config/axios';

export async function obtenerProgramas() {
  return await axios.get(`/analisis_informacion/programas/api/v3/leer_opciones`);
}

export async function obtenerEstadosPrograma(tipo_esquema){
  return await axios.get(`/analisis_informacion/programas/api/v3/leer_estados`, {
    params: {
      tipo_esquema
    }
  });
}

export async function leerPacientesPrograma(tipo_esquema, estados) {
  let strEstados = null;
  if(estados) {
    if(estados.length === 1) {
      strEstados = estados[0]
    } else if(estados.length > 1) {
      strEstados = estados.join(',')
    }
  }
  return await axios.get(`/analisis_informacion/programas/api/v3/leer_pacientes`, {
    params: {
      tipo_esquema,
      estados: strEstados
    }
  });
}


export async function obtenerColecciones() {
  return await axios.get('/analisis_informacion/colecciones/api/v3/leer');
}


export async function obtenerDocumentosColeccion(collection) {
  return await axios.get(`/analisis_informacion/${collection}/api/v3/leer_opciones`);
}


export async function clasificarPacientes(collection, tipo_esquema, pacientes, fechaInicial, fechaFinal) {
  return await axios.post(`/analisis_informacion/${collection}/api/v3/clasificar_pacientes`,
    {
      pacientes,
      tipo_esquema,
      fechaInicial,
      fechaFinal,
    });
}


export async function variablesDocumento(collection, tipo_esquema) {
  return await axios.get(`/analisis_informacion/${collection}/api/v3/leer_variables`, {
    params: {
      tipo_esquema
    }
  });
}
export async function analisisFormulario(collection, fechaInicial, fechaFinal, pacientes, consulta, grupo) {
  return await axios.post(`/analisis_informacion/${collection}/api/v3/grupos`,
    {
      fechaInicial,
      fechaFinal,
      pacientes,
      consulta,
      grupo
    });
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudAnalisisDeFormulario.js